import { FeatureFlag } from '../FeatureFlag';

export const backtestJobsListPollingIntervalMs = new FeatureFlag<number>({
    key: 'backtest-jobs-list-polling-interval-ms',
    createdOn: '2026-03-25',
    defaultValue: 5000,
});
